///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { StaticContentDTO } from '../../../generated/shared-types.model';
import { GtthReleaseNotesNewRelease } from './release-note-items/release-notes-new-release.model';
import { ExtendedStaticContent } from './extended-static-content.model';

export class NewReleaseStaticContent implements ExtendedStaticContent {
    public readonly TITLE_TRANSLATION_PATH = 'global.menu.help.releaseNotes.newRelease';
    public readonly TOOLTIP_TRANSLATION_PATH = 'releaseNotes.addNewRelease';
    public id: number;
    public type: string;
    public content: GtthReleaseNotesNewRelease[];

    constructor(data: StaticContentDTO) {
        this.id = data.id;
        this.type = data.type;
        this.content = data.content.map((item) => new GtthReleaseNotesNewRelease(item.date, item.version, item.content));
    }

    getPlainObject(): StaticContentDTO {
        return {
            id: this.id,
            type: this.type,
            content: this.content.map((item: GtthReleaseNotesNewRelease) => item.getPlainObject())
        };
    }

    getTitleTranslationPath() {
        return this.TITLE_TRANSLATION_PATH;
    }

    getTooltipTranslationPath() {
        return this.TOOLTIP_TRANSLATION_PATH;
    }

    update(item: any): GtthReleaseNotesNewRelease {
        return new GtthReleaseNotesNewRelease(item?.date, item?.version, item?.content);
    }
}
